import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      marginBottom: 50,
      marginTop: 64,
    },
    box: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      border: "1px solid",
      borderColor: "grey",
      borderRadius: "10px",
      width: "600px",
      height: "min-content",
      padding: "24px",
      margin: "32px 0",
    },
    header: {
      marginBottom: "12px",
    },
    passwordLengthHint: {
      marginBottom: "12px",
      fontSize: "16px"
    },
    textField: {
      width: "100%",
      marginBottom: "23px",
    },
    buttonBase: {
      margin: "24px 0px",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    saveButton: {
      textTransform: "capitalize",
    },
    inputLabel: {
      color: theme.palette.primary.main,
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.primary.main,
    },
    passwordError: {
      color: "red",
    }
  });
